module.exports = __webpack_public_path__ + "img/two-id.b75b8260.png";